var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 100%;\n\n  input {\n    border: 1px solid #ccc;\n    padding: 0.5rem;\n    width: 100%;\n  }\n'], ['\n  width: 100%;\n\n  input {\n    border: 1px solid #ccc;\n    padding: 0.5rem;\n    width: 100%;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  margin-bottom: 1.25rem;\n'], ['\n  margin-bottom: 1.25rem;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';

export var Form = styled.form(_templateObject);

export var Group = styled.div(_templateObject2);


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/forms/StyledComponents.js
// module id = 231
// module chunks = 4